import React from 'react';
import Avatar from '@strava/ui/Avatar';
import { ActivityIcon } from '@strava/shared-ui/src/ActivityIcon';
import { arrayAddIndexAsId } from '@strava/utils';
import ActivityStats from '../ActivityStats';
import ImageGrid from '../ImageGrid';
import JoinStravaCTA from '../../../JoinStravaCTA';
import { useLoggedOutAthletePageContext } from '../../../../state/LoggedOutAthletePageContext';

import styles from './RecentActivities.module.scss';

const RecentActivities = () => {
  const { t, state } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { recentActivities, athlete } = athleteData;

  return (
    <div className={styles.recentActivities}>
      <ol className={styles.recentActivitiesList}>
        {recentActivities.map((activity) => (
          <li
            className={styles.card}
            key={activity.id}
            data-testid="recent-activity"
          >
            <div className={styles.cardHeader}>
              <div className={styles.media}>
                <div className={styles.sideColumn}>
                  <Avatar
                    name={athlete.name}
                    src={athlete.avatarUrl}
                    type="athlete"
                  />
                </div>

                <div className={styles.mediaBody}>
                  <time
                    className={styles.timestamp}
                    dateTime={activity.startDateLocal}
                  >
                    {activity.startDateLocal}
                  </time>
                  <h4 className={styles.title}>{activity.name}</h4>
                </div>
              </div>

              <div className={styles.media}>
                <div className={styles.sideColumn}>
                  <ActivityIcon
                    type={activity.detailedType}
                    size="small"
                    title={t(`activities.types.${activity.type}`)}
                    data-testid="activity-icon"
                  />
                </div>

                <div className={styles.mediaBody}>
                  <ActivityStats activity={activity} />
                </div>
              </div>
            </div>
            {activity.images.length > 0 && (
              <div className={styles.cardBody} data-testid="activity-images">
                <ImageGrid images={arrayAddIndexAsId(activity.images)} />
              </div>
            )}
          </li>
        ))}
      </ol>
      <JoinStravaCTA
        className={styles.joinStravaCTA}
        heading={t('mobile_cta')}
        linkConfig={{
          href: '/register',
          text: t('get_strava_cta')
        }}
        trackConfig={{
          element: 'start_signup',
          signupCopy: 'get_strava_1'
        }}
      />
    </div>
  );
};

export default RecentActivities;
